<template>
    <basicLayout>
        <h5>HANDLING</h5>
        <div class="row">
            <div class="col-xl-6">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Search...</span>
                    </div>
                    <input @input="debounce_search" :value="search" type="text" class="form-control"
                        placeholder="Seq Number, Code, Name" />
                    <div class="input-group-append">
                        <button @click="clear_search" class="btn btn-outline-secondary" type="button">
                            Clear
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">

            <div class="col-xl-6">
                <input v-model="age" type="range" class="custom-range" min="1" max="56" step="1" />
            </div>
            <div class="col-3">
                Age Limit: <small>{{ age }} Days</small>
            </div>
        </div>


        <div class="row m-2">



            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a @click="tab = 'jobs'" :class="['nav-link', { active: tab === 'jobs' }]" aria-current="page"
                        href="#">Jobs</a>
                </li>
                <li class="nav-item">
                    <a @click="tab = 'stats'" :class="['nav-link', { active: tab === 'stats' }]" href="#">Stats</a>
                </li>

            </ul>

        </div>

        <div class="row m-2" v-if="tab === 'jobs'">
            <div class="tableFixHead">
                <table class="table table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th class="text-left">Start Date</th>
                            <th class="text-left">Customer</th>
                            <th class="text-right">Total Items</th>
                            <th class="text-left">User</th>
                            <th>Total Time</th>
                            <th>Time per Item</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="job in filtered" :key="job.id">
                            <td class="text-left">
                                {{ job.start_time | moment_short }}
                            </td>
                            <td class="text-left">
                                {{ job.name }}
                            </td>
                            <td class="text-right">
                                {{ job.processing }}
                            </td>
                            <td class="text-left">
                                {{ job.assigned_users.join(", ") }}
                            </td>

                            <td>{{ job.duration }}</td>
                            <td>{{ job.duration_per_item }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <Pagination v-if="pages" :pages="pages" :selected_page="selected_page" v-on:updatePage="updatePage" />
        </div>



        <div class="row m-2" v-if="tab === 'stats'">
            <div class="tableFixHead">
                <table class="table table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th> User</th>
                            <th>Total Jobs</th>
                            <th>Total Items</th>
                            <th>Total Time</th>
                            <th class="text-left">Average Time Per Job</th>
                            <th class="text-left">Average Time Per Item </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="job in stats" :key="job.id">
                            <td class="text-left">
                                {{ job.user }}</td>

                            <td class="text-left">
                                {{ job.jobCount }}</td>
                            <td class="text-left">
                                {{ job.totalItems }}</td>
                            <td class="text-left">
                                {{ job.totalTime }}</td>
                            <td class="text-left">
                                {{ job.averageTimePerJob }}</td>
                            <td class="text-left">
                                {{ job.averageTimePerItem }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <Pagination v-if="pages" :pages="pages" :selected_page="selected_page" v-on:updatePage="updatePage" /> -->
        </div>



    </basicLayout>
</template>

<script>
import { fb, db } from "@/firebaseConfig";
import { orderBy } from "lodash";
import basicLayout from "@/components/basicLayout";
import filter_mixins from "@/mixins/filter_mixins";
import sort_mixins from "@/mixins/sort_mixins";
import utility_mixins from "@/mixins/utility_mixins";
import Pagination from "@/components/Pagination";
import { ListIcon, FileTextIcon, CompassIcon } from "vue-feather-icons";

const jobs = db.collection("daily_lists");

export default {
    name: "jobs",
    data() {
        return {
            tab: "jobs",
            display_jobs: [],
            age: 7,
            search: "",
            debounce: null,
            sort_column: ["code"],
            sort_order: "asc",
            page_limit: 300,
            selected_page: 1,
        };
    },
    components: {
        basicLayout,
        Pagination,
        ListIcon,
        FileTextIcon,
        CompassIcon,
    },
    mixins: [filter_mixins, sort_mixins, utility_mixins],

    // firestore() {
    //     let start_date = new Date(Date.now() - this.age * 24 * 60 * 60 * 1000);
    //     console.log("Start Date:", start_date);
    //     return {
    //         jobs: db
    //             .collection("daily_lists")
    //             .where("is_archived", "==", true)
    //             .where("start_time", ">", start_date)
    //             .orderBy("start_time", "desc")
    //             .limit(500),
    //     };
    // },
    methods: {
        debounce_search(event) {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.search = event.target.value;
            }, 200);
        },
        see_lines(ssid) {
            this.$router.push({
                name: "ShippedLines",
                params: { ssid: ssid },
            });
        },
        filter_by(filter) {
            this.search = filter;
        },
        sort_by(column) {
            this.sort_column = column;
            this.sort_order = this.sort_order === "asc" ? "desc" : "asc";
        },
        clear_search() {
            this.search = "";
        },
        updatePage(value) {
            this.selected_page = value;
            this.clear_search();
        },

        toMs(timestamp) { return timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000; },
        duration(job) { return this.toMs(job.finish_time) - this.toMs(job.start_time); },

        formatDuration: (ms) => {
            const totalSeconds = Math.floor(ms / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            if (hours > 0) {
                return `${hours}h ${minutes}m ${seconds}s`;
            }
            if (minutes > 0) {
                return `${minutes}m ${seconds}s`;
            }
            return `${seconds}s`;
        }
    },
    computed: {

        stats() {

            let visible_jobs = this.display_jobs.slice();


            const userStats = visible_jobs.reduce((acc, job) => {
                if (!job.start_time || !job.finish_time) return acc;

                const duration = this.toMs(job.finish_time) - this.toMs(job.start_time);

                job.assigned_users.forEach(user => {
                    if (!acc[user]) {
                        acc[user] = { totalTime: 0, jobCount: 0, totalItems: 0 };
                    }
                    acc[user].totalTime += duration;
                    acc[user].jobCount += 1;
                    acc[user].totalItems += job.processing || 0;
                });

                return acc;
            }, {});

            // Calculate averages
            const averages = Object.entries(userStats).map(([user, stats]) => ({
                user,
                jobCount: stats.jobCount,
                totalItems: stats.totalItems,
                totalTime: this.formatDuration(stats.totalTime),
                averageTimePerJob: this.formatDuration(stats.totalTime / stats.jobCount),
                averageTimePerItem: this.formatDuration(stats.totalTime / stats.totalItems)
            }));

            return averages


        },




        filtered() {
            let visible_jobs = this.display_jobs.slice();

            visible_jobs = visible_jobs.map(job => {

                const duration = this.toMs(job.finish_time) - this.toMs(job.start_time);
                const duration_per_item = duration / job.processing;

                job.duration = this.formatDuration(duration)
                job.duration_per_item = this.formatDuration(duration_per_item);
                return job
            }

            )

            const search = this.search;

            if (this.sort_column) {
                visible_jobs = orderBy(
                    visible_jobs,
                    (item) => item[this.sort_column] || "",
                    this.sort_order
                );
            }

            visible_jobs = visible_jobs.filter((job) => {
                const s = Object.values(job);
                const su = s.toString().toUpperCase();
                return su.match(search.toString().toUpperCase());
            });


            if (!search) {
                const start = (this.selected_page - 1) * this.page_limit;
                const end = start + this.page_limit;
                visible_jobs = visible_jobs.slice(start, end);
            }

            return visible_jobs;
        },
        pages() {
            const pages_array = this.search ? this.filtered : this.display_jobs;
            return Math.ceil(pages_array.length / this.page_limit);
        },
    },


    watch: {
        age: {
            immediate: true,
            handler(age) {
                if (age) {
                    let start_date = new Date(Date.now() - age * 24 * 60 * 60 * 1000);
                    this.$bind(
                        "display_jobs",
                        jobs
                            .where("is_archived", "==", true)
                            .where("start_time", ">", start_date)
                            .orderBy("start_time", "desc")
                            .limit(500),
                    );
                }
            }
        }


    }
};
</script>

<style scoped></style>
